import { useNavigate } from 'react-router-dom';
import { scrollToSection } from '@/utils/scrollToSection';

const industries = [
  { icon: '🛍', name: 'Ecommerce', label: 'DTC & Marketplace', anchor: 'ind-ecommerce' },
  { icon: '🏪', name: 'Retail', label: 'Multi-location chains', anchor: 'ind-retail' },
  { icon: '💊', name: 'Pharma', label: 'Cold chain compliant', anchor: 'ind-pharmaceuticals' },
  { icon: '📸', name: 'Fashion', label: 'Returns & visual QC', anchor: 'ind-fashion' },
  { icon: '🥤', name: 'FMCG', label: 'High-volume throughput', anchor: 'ind-fmcg' },
  { icon: '📱', name: 'Electronics', label: 'Secure & serialized', anchor: 'ind-electronics' },
  { icon: '🏦', name: 'Banks / Fintech', label: 'POS storage & distrib.', anchor: 'ind-banks' },
  { icon: '☀', name: 'Renewable Energy', label: 'Solar & clean energy', anchor: 'ind-renewable' },
  { icon: '❤', name: 'NGOs', label: 'Humanitarian logistics', anchor: 'ind-ngos' },
  { icon: '🚜', name: 'Importers', label: 'Container & bulk distrib.', anchor: 'ind-importers' },
];

export default function IndustriesSection() {
  const navigate = useNavigate();

  const goToIndustry = (anchor: string) => {
    navigate('/industries');
    scrollToSection(anchor);
  };

  return (
    <section className="py-24 px-6" style={{ background: '#0A0A0F' }}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="eyebrow">Industries</p>
          <h2 className="section-heading mb-2">Built for Every Sector</h2>
          <p className="section-lead max-w-xl">
            From fast-moving consumer goods to regulated pharma. THL adapts to your industry.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {industries.map(ind => (
            <button
              key={ind.name}
              onClick={() => goToIndustry(ind.anchor)}
              className="group bg-thl-dark3 border border-thl-border rounded-xl p-4 text-center hover:border-thl-red/40 hover:bg-thl-dark4 transition-all duration-200 cursor-pointer"
            >
              <div className="text-2xl mb-2">{ind.icon}</div>
              <div className="text-white text-sm font-semibold group-hover:text-thl-red transition-colors">{ind.name}</div>
              <div className="text-white/40 text-xs mt-1">{ind.label}</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
